import { createLogic } from 'redux-logic';
import { formFindersLoadExisting, formFindersLoaded, formFinderSelect } from '../actions';
import { apiGet } from '../api';
import find from 'lodash/find';

const loadExistingFormFinders = createLogic({
    type: formFindersLoadExisting,
    latest: true,
    async process({ getState }, dispatch, done) {
        const authContext = getState().authentication;
        const token = await authContext.getAccessToken(authContext.authorizationScopes.formFinders);

        apiGet('/formFinders/', token)
            .then((result) => {
                dispatch(formFindersLoaded(result.data));
            })
            .catch(() => {})
            .finally(done);
    },
});

const selectFormFinder = createLogic({
    type: formFinderSelect,
    latest: true,
    transform({ getState, action }, next) {
        const formId = action.payload;
        const { forms } = getState();
        const form = find(forms.existing, (form) => form.id.toString() === formId) || {};

        next({
            ...action,
            payload: form,
        });
    },
});

export default [loadExistingFormFinders, selectFormFinder];
